import '../../css/mk-brand.css';
import {useEffect, useState} from "react";
import Nft from "../nft-control";
import {getNftsFromWallet} from "../../candy-utils";
import config from "../../config";
import {useConnection, useWallet} from "@solana/wallet-adapter-react";
import {gPageView} from "../../google-analytics";
import Toast from "../toast-control";
import MKCoin from "../../media/MK-coin.png";
import GameClient from "../../lib/game-client";
import SuperOgPanels from "../../constants/super-og-panels";
import SuperOgGameStates from "../../constants/super-og-game-states";

const MAX_WAGER_CHEF = 100;
function Panel({onChangePanel, data, loading}) {
    const [isDisabled, setDisabled] = useState(false);
    const wallet = useWallet();
    const {connection} = useConnection();
    const [handle, setHandle] = useState(data?.game?.handle);
    const [isSOLWager, setIsSOLWager] = useState(data?.game?.isSOL);
    const [wager, setWager] = useState(data?.game?.amount);
    const [myOgChefs, setMyOgChefs] = useState([]);
    const [availableOgChefs, setAvailableOgChefs] = useState([]);
    const [selectedChefs, setSelectedChefs] = useState([]);
    const [alertState, setAlertState] = useState({
        open: false,
        message: '',
        severity: undefined,
    });
    useEffect(() => {
        gPageView('super-og-setup');
        (async () => {
            if (!handle) {
                setHandle(data?.game?.handle);
            }
            if (wallet) {
                await onGetAccountInfo();
            }
        })();
    }, [wallet, connection, selectedChefs]);

    const onChangeWager = (e) => {
        if (data?.game?.state !== SuperOgGameStates.start) return; // only change wager if in the 'start' state.
        const newWagerValue = parseInt(e);
        if (isNaN(e) || (newWagerValue > 0 && newWagerValue > MAX_WAGER_CHEF)) {
            setAlertState({
                open: true,
                message: 'Wager must be a number between 1 and 100.',
                severity: 'danger',
            });
        } else {
            if (alertState.open && alertState.message.indexOf('Wager') === 0) {
                setAlertState({
                    open: false,
                    message: '',
                    severity: 'info',
                })
            }
            setWager(newWagerValue);
        }
    }
    const onGetAccountInfo = async () => {
        try {
            if (wallet && wallet.connected) {
                setAlertState({
                    open: false,
                    message: '',
                    severity: 'info',
                });
                const chefsInPlay = await GameClient.getChefsInPlay(wallet.publicKey.toString());
                const allMyChefs = await getNftsFromWallet(connection, config.OG_CHEFS_CANDY_MACHINE_ID, wallet.publicKey);
                const ogChefs = allMyChefs.filter(chef => {
                    const inPlay = chefsInPlay?.find(cip => chef.mint === cip);
                    return !(inPlay); // if the chef is already in play then filter it from the list.
                });
                // need to filter the ones already in play.
                setAvailableOgChefs(ogChefs);
                setMyOgChefs(ogChefs);
            } else {
                setAlertState({
                    open: true,
                    message: 'Please connect your wallet to see your chefs.',
                    severity: '',
                });
            }

        } catch (error) {
            let message = error.msg || 'Could not access your wallet. Please try again.';
            if (!error.msg) {
                if (error.message.indexOf('0x138')) {
                } else if (error.message.indexOf('0x137')) {
                    message = `SOLD OUT!`;
                } else if (error.message.indexOf('0x135')) {
                    message = `Insufficient funds to mint. Please fund your wallet.`;
                }
            }
            setAlertState({
                open: true,
                message,
                severity: 'danger',
            });
        } finally {

        }
    };
    const getAvailableChefs = () => {
        return myOgChefs.filter( (chef => {
            if (selectedChefs.length > 2) {
                return false;
            } else {
                let result = true;
                const starTracker = [ 0, 0, 0, 0, 0];
                selectedChefs.forEach(selectedChef => {
                        if (selectedChef.metadata.name === chef.metadata.name) { result = false;} // can't add the same chef twice
                        const selectedChefStars = GameClient.getStars(selectedChef);
                        starTracker[selectedChefStars - 1]++;
                    }
                );

                if (starTracker[GameClient.getStars(chef) - 1] > 1 ) {
                    result = false; // filter chefs when we already have 2 of that category selected
                }
                return result;
            }
        }) ).sort((a,b) => {
            return a.metadata.name > b.metadata.name;
        })
    }
    const onSelectNFT = (selectedChef) => {
        const alreadySelectedNft = selectedChefs.find(chef => chef.metadata.name === selectedChef.metadata.name);
        if (!alreadySelectedNft) {
            selectedChefs.push(selectedChef);
            setSelectedChefs(selectedChefs);
            setAvailableOgChefs(getAvailableChefs());
        }
    }
    const onUnselect = (chefIndex) => {
        if (selectedChefs[chefIndex]) {
            selectedChefs.splice(chefIndex, 1);
            setSelectedChefs(selectedChefs);
            setAvailableOgChefs(getAvailableChefs());
        }
    }
    const isWagerSelected = (targetWager) => {
        return targetWager == wager;

    }
    if (!data?.game) return null; else
    return (
        <div id="super-og-set" className="m-2">
            <div className="max-w-lg w-full">
                <Toast
                    open={alertState.open}
                    message={alertState.message}
                    severity={alertState.severity}
                    onClose={() => setAlertState({...alertState, open: false})}
                />
            </div>
            <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-4xl">
                <div className="flex flex-row">
                    <div className="max-w-2xl mx-auto mb-10">
                        <div className="flex-row">
                            <div className="flex text-6xl mb-1">
                                <div className="text-brand font-extrabold">Super</div><div className="font-extrabold">OG</div>
                            </div>
                            <div className="text-brand-text text-2xl pull-right cursor-pointer hover:font-bold">
                                <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/the-menu/game-mechanics/ready-set-whip">
                                    Set up
                                </a>
                            </div>
                            <button className="text-brand-text bg-brand font-bold rounded-lg p-2 m-1"
                                    onClick={async () => {
                                        await onChangePanel(SuperOgPanels.Lobby);
                                    }}>Back to Lobby
                            </button>
                            <div className="border border-brand mb-2" />
                            <div className="flex justify-between mx-auto space-x-4">
                                <div className="space-y-1">
                                    <div className="flex my-auto">
                                        <div className="flex-col my-auto">Handle:&nbsp;</div>
                                        <div className="flex-col bg-zinc-400 p-2 rounded-lg ">{handle}</div>
                                    </div>
                                    <div className="flex-row">
                                        {
                                            data?.game?.state === SuperOgGameStates.start ?
                                                <div className="flex flex-row my-auto space-x-1 ml-4">
                                                    <div className="space-x-1">
                                                        <span className="">Wager:</span>
                                                        <div className="container w-full flex space-x-1 justify-between" id="wager-group-id">
                                                            <div
                                                                id="wager-1-id"
                                                                className={`flex cursor-pointer ${isWagerSelected(1) ? 'bg-brand-hover' : 'bg-zinc-500'} rounded-lg hover:bg-brand-hover p-1`}
                                                                onClick={() => {onChangeWager(1);}}
                                                            >
                                                                <span className="my-auto p-1 text-xl">1</span>
                                                                <span className="my-auto">$CHEF</span>
                                                                <img src={MKCoin} className="max-h-8" />
                                                            </div>
                                                            <div
                                                                id="wager-5-id"
                                                                className={`flex cursor-pointer ${isWagerSelected(5) ? 'bg-brand-hover' : 'bg-zinc-500'} rounded-lg hover:bg-brand-hover p-1`}
                                                                onClick={() => {onChangeWager(5);}}
                                                            >
                                                                <span className="my-auto p-1 text-xl">5</span>
                                                                <span className="my-auto">$CHEF</span>
                                                                <img src={MKCoin} className="max-h-8" />
                                                            </div>
                                                            <div
                                                                id="wager-25-id"
                                                                className={`flex cursor-pointer ${isWagerSelected(25) ? 'bg-brand-hover' : 'bg-zinc-500'} rounded-lg hover:bg-brand-hover p-1`}
                                                                onClick={() => {onChangeWager(25);}}
                                                            >
                                                                <span className="my-auto p-1 text-xl">25</span>
                                                                <span className="my-auto">$CHEF</span>
                                                                <img src={MKCoin} className="max-h-8" />
                                                            </div>
                                                            <div
                                                                id="wager-100-id"
                                                                className={`flex cursor-pointer ${isWagerSelected(100) ? 'bg-brand-hover' : 'bg-zinc-500'} rounded-lg hover:bg-brand-hover p-1`}
                                                                onClick={() => {onChangeWager(100);}}
                                                            >
                                                                <span className="my-auto p-1 text-xl">100</span>
                                                                <span className="my-auto">$CHEF</span>
                                                                <img src={MKCoin} className="max-h-8" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="flex  my-auto space-x-1">
                                                    <span className="">Wager:&nbsp;</span>
                                                    <div className="py-1 px-5 w-full rounded-lg text-brand-text bg-zinc-400 ">
                                                        {data.game.amount + ' ' + (data.game.isSOL ? '$SOL' : '$CHEF')}
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className="my-auto">
                                    {
                                        selectedChefs.length === 3 ?
                                            <div>
                                                <button
                                                    className={`${isDisabled ? 'bg-zinc-500' : 'bg-brand'} text-xl font-extrabold p-4 pull-right rounded-lg`}
                                                    disabled={isDisabled}
                                                    onClick={async () => {
                                                        loading(true);
                                                        setDisabled(true);
                                                        if (data.game.state === SuperOgGameStates.start) {
                                                            // we are opening a game
                                                            data.game = {
                                                                ...data.game,
                                                                amount: wager,
                                                                champChef1Mint: selectedChefs[0].mint,
                                                                champChef1Uri: selectedChefs[0].metadata.uri,
                                                                champChef2Mint: selectedChefs[1].mint,
                                                                champChef2Uri: selectedChefs[1].metadata.uri,
                                                                champChef3Mint: selectedChefs[2].mint,
                                                                champChef3Uri: selectedChefs[2].metadata.uri,
                                                            };
                                                            const gameResult = await GameClient.deploySuperOGChallenge(data.game, connection, wallet, wager);
                                                            onChangePanel(SuperOgPanels.Alert, {game: gameResult});
                                                        } else {
                                                            // we are accepting and exiting challenge
                                                            data.game = {
                                                                ...data.game,
                                                                challengerWalletPK: wallet.publicKey.toString(),
                                                                challengerChef1Mint: selectedChefs[0].mint,
                                                                challengerChef1Uri: selectedChefs[0].metadata.uri,
                                                                challengerChef2Mint: selectedChefs[1].mint,
                                                                challengerChef2Uri: selectedChefs[1].metadata.uri,
                                                                challengerChef3Mint: selectedChefs[2].mint,
                                                                challengerChef3Uri: selectedChefs[2].metadata.uri,
                                                            };
                                                            const gameResult = await GameClient.acceptAndEvalSuperOGChallenge(data.game, connection, wallet, wager);
                                                            onChangePanel(SuperOgPanels.Alert, {game: gameResult});
                                                        }
                                                        setDisabled(false);
                                                        loading(false);
                                                    }}
                                                >
                                                    Approve
                                                    <p className="text-xs">{wager} {isSOLWager ? '$SOL' : '$CHEF'}</p>
                                                </button>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="border border-brand mt-2" />
                        </div>
                        <h1 className="mb-6 mt-6 text-white md:text-2xl">
                            {wallet.publicKey.toString() == data?.game?.champWalletPK && data?.game.state !== SuperOgGameStates.start ? 'This is your challenge and you CAN NOT play against yourself.' : 'Please select three OG Chefs'}
                        </h1>
                        <div className="bg-brand-hover p-2 rounded-lg">
                            <div id="selectedChefs" className="md:flex justify-center md:space-x-2 space-y-1">
                                <div id="firstChef" className="flex flex-col text-center p-2 bg-zinc-400 rounded-lg" >
                                    {selectedChefs[0] ?
                                        <div className="flex justify-between">
                                            {GameClient.getStarsHtml(selectedChefs[0])}
                                            <span className="rounded-lg bg-zinc-500 px-2 mb-1 cursor-pointer" onClick={() =>{
                                                onUnselect(0);
                                            }}>X</span>
                                        </div>
                                        : null}
                                    {selectedChefs[0] ?
                                        <img className="mx-auto w-40 max-h-38 rounded-lg" src={selectedChefs[0].json.image} />
                                        :
                                        <div className="mx-auto fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                </div>
                                <div id="secondChef" className="flex flex-col text-center p-2 bg-zinc-400 rounded-lg" >
                                    {selectedChefs[1] ?
                                        <div className="flex justify-between">
                                            {GameClient.getStarsHtml(selectedChefs[1])}
                                            <span className="rounded-lg bg-zinc-500 px-2 mb-1 cursor-pointer" onClick={() =>{
                                                onUnselect(1);
                                            }}>X</span>
                                        </div>
                                        : null}
                                    {selectedChefs[1] ?
                                        <img className="mx-auto w-40 max-h-38 rounded-lg" src={selectedChefs[1].json.image} />
                                        :
                                        <div className="mx-auto fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                </div>
                                <div id="thirdChef" className="flex flex-col text-center p-2 bg-zinc-400 rounded-lg" >
                                    {selectedChefs[2] ?
                                        <div className="flex justify-between">
                                            {GameClient.getStarsHtml(selectedChefs[2])}
                                            <span className="rounded-lg bg-zinc-500 px-2 mb-1 cursor-pointer" onClick={() =>{
                                                onUnselect(2);
                                            }}>X</span>
                                        </div>
                                        : null}
                                    {selectedChefs[2] ?
                                        <img className="mx-auto w-40 max-h-38 rounded-lg" src={selectedChefs[2].json.image} />
                                        :
                                        <div className="mx-auto fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                </div>
                            </div>
                            <br />
                        </div>
                        <br />
                        <div>
                            <p>Click on the Chefs BELOW in the order you wish to play them. You may only use a MAXIMUM of TWO (2) chefs with the same star rating.</p>
                            {
                                (availableOgChefs.length < (3 - selectedChefs.length)) ? <div className="bg-brand-text text-brand font-extrabold p-4 m-2 rounded-lg">
                                    <div className="text-center text-2xl">You do not have enough chefs to play this game!</div>
                                    <hr/>
                                    <div className="p-2">
                                        You must have at least 3 chefs NOT IN PLAY. Either buy more chefs or cancel one of your open challenges.
                                    </div>
                                </div> : null
                            }
                        </div>
                        {availableOgChefs && (wallet?.publicKey?.toString() !== data?.game?.champWalletPK || data?.game?.state === SuperOgGameStates.start) ? <div className="max-w-7xl flex flex-row flex-wrap justify-items-center align-middle">{
                            availableOgChefs.map(nft => {
                                if (!nft.selected) {
                                    return <Nft key={nft.metadata.name} onClick={onSelectNFT} nft={nft} superOg={true}/>;
                                }
                            })
                        }</div> : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Panel;